import React from "react";
import styled from "styled-components";
import { RichText } from "prismic-dom";
import { ellipsis, shade } from "polished";
import { Box, Flex } from "rebass";
import { ChevronDown, ChevronRight } from "react-feather";
import Article from "./Article";
import ImageSlice from "./ImageSlice";
import BlockQuote from "./BlockQuote";
import H2 from "./Headings/H2";

const Wrapper = styled(Box)`
  border-bottom: 1px solid
    ${(props) =>
      props.theme.colors.grey[1] && shade(0.875, props.theme.colors.grey[1])};
  &:first-child {
    margin-top: -16px;
  }
`;

Wrapper.defaultProps = {};

const ButtonContainer = styled(Flex)`
  position: relative;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: initial;
  font-family: ${(props) => props.theme.fonts.sans};
  appearance: none;
  background: transparent;
  border: none;
  cursor: pointer;
  &:not(:lang(ar)) {
    padding-right: 0;
    padding-left: 40px;
  }
  &:lang(ar) {
    padding-right: 40px;
    padding-left: 0;
  }
  &:hover {
    span {
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.grey[0]};
    }
  }
  &:active {
    span {
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.grey[1]};
    }
  }
`;

ButtonContainer.defaultProps = {
  is: "button",
};

const IconContainer = styled(Box)`
  position: absolute;
  top: 50%;
  width: 32px;
  height: 32px;
  transform: translateY(-50%);
  &:not(:lang(ar)) {
    left: 0;
  }
  &:lang(ar) {
    right: 0;
  }
`;

const AccordionTitle = styled(H2)`
  ${ellipsis()};
  > span {
    display: inline-block;
    height: 100%;
    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
  }
`;

AccordionTitle.defaultProps = {
  is: "h1",
};

const ContentContainer = styled(Box)`
  /* transform: scaleY(0); */
`;

const Content = styled(Box)`
  padding-top: 16px;
  padding-bottom: 32px;
`;

Content.defaultProps = {
  is: "article",
};

var linkResolver = function (doc) {
  return "/" + doc.type;
};

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.startOpen ? true : false,
    };
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    return (
      <Wrapper>
        <ButtonContainer
          onClick={this.toggleOpen}
          role="tab"
          aria-controls={this.props.id}
          aria-expanded={this.state.open}
          role="tab"
          aria-selected={this.state.open}
        >
          <IconContainer>
            {this.state.open && (
              <ChevronDown size={32} strokeWidth={1.25} stroke="#363636" />
            )}
            {!this.state.open && (
              <ChevronRight size={32} strokeWidth={1.25} stroke="#363636" />
            )}
          </IconContainer>
          <AccordionTitle fontSize={[4, 5]}>
            <span>{this.props.title}</span>
          </AccordionTitle>
        </ButtonContainer>
        <ContentContainer aria-labelledby={this.props.id} role="tabpanel">
          {this.state.open && (
            <Content>
              {this.props.children}
              {this.props.data.map((slice, index) => {
                if (slice.slice_type === "text") {
                  return (
                    <Article
                      is="div"
                      dangerouslySetInnerHTML={{
                        __html: RichText.asHtml(
                          slice.primary.text,
                          linkResolver
                        ),
                      }}
                    />
                  );
                }
                if (slice.slice_type === "image") {
                  return (
                    <ImageSlice
                      imageSet={[
                        slice.primary.image.url,
                        slice.primary.image.half.url,
                        slice.primary.image.quarter.url,
                      ]}
                      caption={slice.primary.caption}
                      alt={slice.primary.image.alt}
                    />
                  );
                }
                if (slice.slice_type === "quote") {
                  return (
                    <BlockQuote
                      quote={
                        slice.primary.quote[0]
                          ? slice.primary.quote[0].text
                          : ""
                      }
                      attribution={
                        slice.primary.name_of_the_author[0]
                          ? slice.primary.name_of_the_author[0].text
                          : ""
                      }
                    />
                  );
                }
              })}
            </Content>
          )}
        </ContentContainer>
      </Wrapper>
    );
  }
}

Accordion.defaultProps = {
  title: "Overview",
  id: "overview_tab",
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Accordion.js